import React from 'react';
import PropTypes from 'prop-types';
import Dashboard from 'common/components/dashboard';
import DashboardSwitcher from 'common/components/dashboard-switcher';
import ShadedBackground from 'common/components/shaded-background';
import ZeroStateCard from 'common/components/zero-state-card';

export default class ApplicationHome extends React.Component {
  static propTypes = {
    dashboard: PropTypes.object.isRequired,
    dashboards: PropTypes.object,
    setDashboard: PropTypes.func.isRequired,
    userCanEditDashboard: PropTypes.bool.isRequired,
    zeroState: PropTypes.shape({
      buttonClass: PropTypes.string,
      buttonTitle: PropTypes.string,
      message: PropTypes.string,
      onButtonClick: PropTypes.func,
    }).isRequired,
  };

  render() {
    const {
      dashboard,
      dashboards,
      setDashboard,
      userCanEditDashboard,
      zeroState,
    } = this.props;
    return (
      <ShadedBackground>
        <div className='ContainerMain ContainerMain--no-padding'>
          <DashboardSwitcher
            currentDashboard={dashboard}
            dashboards={dashboards}
            setDashboard={setDashboard}
            userCanEditDashboard={userCanEditDashboard}
          />
          {dashboard.id ? (
            <Dashboard
              dashboard={dashboard}
              hasPadding={false}
              readonly={true}
              userCanEditDashboard={userCanEditDashboard}
            />
          ) : (
            <ZeroStateCard {...zeroState} />
          )}
        </div>
      </ShadedBackground>
    );
  }
}
